import styled from 'styled-components';

type TResponsive = {
  isMobile?: boolean;
  isDesktop?: boolean;
  isMediumSize?: boolean;
  background?: boolean;
};

export const Container = styled.div<TResponsive>`
  background: #f8f8f8;

  ${(props) =>
    props.isDesktop &&
    `
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: fit-content(100%);
    margin:auto;

    .left_aux_grid_1 {
      grid-column-start: 1; 
      grid-row-start: 1; 
    }

    .right_aux_grid_1 {
      grid-column-start: 3; 
      grid-row-start: 1; 
    }

    .left_aux_grid_9 {
      grid-column-start: 1; 
      grid-row-start: 9; 
    }

    .right_aux_grid_9 {
      grid-column-start: 3; 
      grid-row-start: 9; 
    }

    .left_aux_grid_7 {
      grid-column-start: 1; 
      grid-row-start: 7; 
    }

    .right_aux_grid_7 {
      grid-column-start: 3; 
      grid-row-start: 7; 
    }

    .section_content{
      grid-column-start: 2; 
    }

    .left_aux_grid_10 {
      grid-column-start: 1; 
      grid-row-start: 4; 
    }

    .right_aux_grid_10 {
      grid-column-start: 3; 
      grid-row-start: 4; 
    }
    
  `}
`;

export const AuxiliarySide = styled.div<{ height?; backgroundColor? }>`
  background-color: white;
  height: ${(props) => props.height || '517px'};
  background-color: ${(props) => props.backgroundColor || 'white'}; ;
`;

export const SectionPrimary = styled.div<TResponsive>`
  text-align-last: center;
  background: #ffffff;
  height: 488px;
  display: grid;
  margin-bottom: 96px;

  ${(props) =>
    props.isDesktop &&
    `  
    text-align-last: left;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    column-gap:103px;    
    margin: auto;
    height: 517px;
    margin-bottom: 96px;
    max-width: 900px;
    width: 900px;

    .grid_1 {
      order: 1;
      grid-column-start: 1; 
    }

    .grid_2 {
      order: 2;
      grid-column-start: 2; 
      grid-row-start: 1; 
    }

    .grid_3 {
      order: 3;
      grid-column-start: 1; 
      grid-row-start: 2; 
      grid-row-end: 2; 
    }
  `}

  ${(props) =>
    props.isMediumSize &&
    `
    margin-bottom:115px;
  `}
`;

export const MainTitle = styled.h1<TResponsive>`
  width: 294px;
  height: fit-content;
  font-weight: 900;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: -0.024em;
  color: #000000;
  margin: auto;
  margin-bottom: 32px;
  padding-top: 70px;
  z-index: 10;

  ${(props) =>
    props.isDesktop &&
    `
  padding:0;
  width: 491px;
  font-size: 44px;
  line-height: 50px;
  display: flex;
  align-items: center;
  letter-spacing: -0.024em;
  text-align-last: left;
  align-items: start;
  margin-bottom: 96px;
  margin-top: 173px;

  @media screen and (max-height: 768px) {
    margin-top: 100px;
  }
`}

  ${(props) =>
    props.isMediumSize &&
    `
    width: 480px;
    font-size: 40px;
    text-align: center;
    line-height: 40px;
  `}
`;

export const BoxImageMain = styled.div<TResponsive>`
  text-align: center;
  height: max-content;
  position: relative;

  ${(props) =>
    props.isDesktop &&
    `
text-align: start;
margin-top: 96px;

@media screen and (max-height: 768px) {
  margin-top: 60px;
}
`}

  ${(props) =>
    props.isMediumSize &&
    `
  max-width: 306px;
  place-self: center;
`}
`;

export const BoxButton = styled.div<TResponsive>`
  min-width: 328px;
  background: #ffffff;
  box-shadow: 0px 10px 25px rgba(120, 120, 120, 0.06);
  border-radius: 24px;
  padding: 24px;
  margin-top: 32px;
  margin-left: 16px;
  margin-right: 16px;
  display: grid;

  ${(props) =>
    props.isDesktop &&
    `
    margin-top: 14px;
    margin-left: 0;
    margin-right: 0;
    width: 389px;
  `}

  ${(props) =>
    props.isMediumSize &&
    `
    display:grid;
    margin-top: 0px;
    margin-left: 0px;
    margin-right: 0px;

  `}
`;

export const Item = styled.div<TResponsive>`
  ${(props) =>
    props.isMediumSize &&
    `
  width: 330px;
  margin:auto;
  }
`}
`;

export const SectionSecondary = styled.div<TResponsive>`
  padding: 0 26px 96px 48px;

  ${(props) =>
    props.isDesktop &&
    `
    padding:0;
    margin-bottom:96px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-rows: fit-content(100%);
    column-gap: 103px;

    .grid_1 {
      order: 1;
      grid-column-start: 1; 
    }

    .grid_2 {
      order: 2;
      grid-column-start: 1; 
    }

    .grid_3 {
      order: 3;
      grid-column-start: 1; 
    }

    .grid_4 {
      order:4;
      grid-column-start: 2; 
      grid-row-start: 1; 
      grid-row-end: 4; 
    }
  `};

  ${(props) =>
    props.isMediumSize &&
    `
    display:grid;
    justify-content:center;
    padding: 0 26px 50px 48px;
  `};

  ${(props) =>
    props.background &&
    `
    background: #FFF9EB;
    padding-top: 60px;
    padding-bottom:24px;
  `};
`;

export const Title = styled.h2<TResponsive>`
  width: 280px;
  height: fit-content;
  font-weight: 900;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: -0.024em;
  color: #000000;
  margin-bottom: 32px;
  position: relative;

  ${(props) =>
    props.isDesktop &&
    `
    width: 491px;
    font-size: 44px;
    line-height: 50px;
    display: flex;
    align-items: center;
    letter-spacing: -0.024em;
    text-align-last: left;
    align-items: start;
  `}
`;

export const Description = styled.h3<TResponsive>`
  width: 280px;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.008em;
  color: #6c757d;
  margin: auto 0 32px 0;
  z-index: 10;

  ${(props) =>
    props.isDesktop &&
    `
    margin:0;
    margin-bottom: 24px;
    width: 100%;
  `}
`;

type ButtonLeaseCalculatorProps = {
  borderColor: string;
  iconColor: string;
  backgroundButton?: string;
};

export const ButtonLeaseCalculator = styled.button<ButtonLeaseCalculatorProps & TResponsive>`
  padding: 12px 16px;
  box-sizing: border-box;
  border-radius: 24px;
  margin-bottom: 36px;
  background: ${(props) => props.backgroundButton || '#f8f8f8'};
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  gap: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.2s all ease;
  z-index: 10;

  &:hover {
    box-shadow: 1px 1px 5px 0.5px #a6d7eb;
    transform: translate(5px);
  }

  ${(props) =>
    props.borderColor &&
    `
    border: 2px solid ${props.borderColor};
  `}

  ${(props) =>
    props.iconColor &&
    `
    svg {
      color: ${props.iconColor};
    }
  `};

  ${(props) =>
    props.isDesktop &&
    `
    height: 48px;
    width: max-content;
    margin:0;
  `}
`;

export const BoxImage = styled.div<TResponsive>`
  text-align: center;
  height: max-content;
  position: relative;

  ${(props) =>
    props.isDesktop &&
    `
  text-align: start;
  `}

  ${(props) =>
    props.isMediumSize &&
    `
    width:270px;
    `}
`;
